module.exports = __webpack_public_path__ + "img/14.a43e1a42.png";